var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "nav search-menu-item-info",
      attrs: { "data-testid": "globalsearch-section-vehicle" }
    },
    [_vm._v(" " + _vm._s(_vm.formattedVehicleInfo) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }